import { prepareFormToSubmit } from 'UI/utils/forms';

import { resolveDeclinationStatus } from '../DeclinationReasonsDrawer/DeclinationReasons.shared';

import {
  FORM_FIELDS_MAP,
  SENDOVER_DETAILS_UPDATE_FIELDS_MAP
} from './SendoverDetailsEditForm.constants';

export const isDeclinationStatus = statusId => Boolean(resolveDeclinationStatus(statusId));

export const hasDeclinationReasons = reasonDetails =>
  Array.isArray(reasonDetails?.reasonIds) && reasonDetails.reasonIds.length > 0;

export const buildSendoverDetailsEditDefaultValues = ({ sendover = null }) => ({
  [FORM_FIELDS_MAP.Status.key]: sendover?.status || null,
  [FORM_FIELDS_MAP.DeclinationDetails.key]: isDeclinationStatus(sendover?.status?.id)
    ? sendover?.reasonDetails ?? null
    : null
});

export const buildSendoverDetailsEditPayload = formData => {
  const payload = prepareFormToSubmit(formData, SENDOVER_DETAILS_UPDATE_FIELDS_MAP);

  if (!isDeclinationStatus(payload.statusId)) {
    return payload;
  }

  const reasonDetails = formData?.[FORM_FIELDS_MAP.DeclinationDetails.key];

  return {
    ...payload,
    reasonDetails: {
      reasonIds: reasonDetails?.reasonIds || [],
      notes: reasonDetails?.notes || ''
    }
  };
};
